export default __webpack_public_path__ + "static/media/up.c0c20217.svg";